import call from "../../http";
import { AuthService } from "../auth";
import { DashboardConstants } from "./index";

export default {
  namespaced: true,
  state: {
    //errors
    error: "",
    //vehicles
    vehicles: [],
    vehicleTypes: [],
    drivers: [],
    trips: [],
    payments: [],
    paymentModes: [],
    driverTrips: [],

    // Dashboard counts
    totalDrivers: 0,
    activeDrivers: 0,
    inactiveDrivers: 0,
    totalTrips: 0,
    completedTrips: 0,
    pendingTrips: 0,

    // Creation and update Modal
    driverCreationModal: false,
    vehicleCreationModal: false,
    vehicleUpdateModal: false,
    driverUpdateModal: false,

    tripUpdateModal: false,

    updateDriver: {},
    updateVehicle: {},
    updateTrip: {},

    //Notification Modal modals
    showSuccessModal: false,
    showErrorModal: false,
    showWarningModal: false,

    modalDescription: "",
    modalText: "",

    // trip actions
    cancelReasonOpen: false,
    cancelReasons: [],

    tripAssignRiderOpen: false,
    updateTripStatusOpen: false
  },
  mutations: {
    // Set error
    SET_ERROR: (state, payload) => {
      state.error = payload;
    },

    // Get resources
    GET_VEHICLES: (state, payload) => {
      state.vehicles = payload;
    },
    GET_VEHICLE_TYPES: (state, payload) => {
      state.vehicleTypes = payload;
    },
    GET_DRIVERS: (state, payload) => {
      state.drivers = payload;
    },

    GET_DRIVER_TRIPS: (state, payload) => {
      state.driverTrips = payload;
    },

    GET_TRIPS: (state, payload) => {
      state.trips = payload;
    },

    GET_PAYMENTS: (state, payload) => {
      state.payments = payload;
    },

    GET_PAYMENT_MODES: (state, payload) => {
      state.paymentModes = payload;
    },

    // Show creation modals
    DRIVER_CREATION_MODAL: (state, payload) => {
      state.driverCreationModal = payload;
    },

    DRIVER_UPDATE_MODAL: (state, payload) => {
      state.driverUpdateModal = payload;
    },

    TRIP_UPDATE_MODAL: (state, payload) => {
      state.tripUpdateModal = payload;
    },

    VEHICLE_CREATION_MODAL: (state, payload) => {
      state.vehicleCreationModal = payload;
    },

    VEHICLE_UPDATE_MODAL: (state, payload) => {
      state.vehicleUpdateModal = payload;
    },
    // Set update data
    SET_UPDATE_DRIVER: (state, payload) => {
      state.updateDriver = payload;
    },

    SET_UPDATE_VEHICLE: (state, payload) => {
      state.updateVehicle = payload;
    },

    SET_UPDATE_TRIP: (state, payload) => {
      state.updateTrip = payload;
    },

    // Show notification modal with description and data

    SHOW_SUCCESS_MODAL: (state, payload) => {
      state.showSuccessModal = payload;
    },

    SHOW_ERROR_MODAL: (state, payload) => {
      state.showErrorModal = payload;
    },

    SHOW_WARNING_MODAL: (state, payload) => {
      state.showWarningModal = payload;
    },

    SET_MODAL_DESCRIPTION: (state, payload) => {
      state.modalDescription = payload;
    },

    SET_MODAL_TEXT: (state, payload) => {
      state.modalText = payload;
    },

    // Dashboard

    SET_TOTAL_DRIVERS: (state, payload) => {
      state.totalDrivers = payload;
    },
    SET_ACTIVE_DRIVERS: (state, payload) => {
      state.activeDrivers = payload;
    },
    SET_INACTIVE_DRIVERS: (state, payload) => {
      state.inactiveDrivers = payload;
    },
    SET_TOTAL_TRIPS: (state, payload) => {
      state.totalTrips = payload;
    },
    SET_COMPLETED_TRIPS: (state, payload) => {
      state.completedTrips = payload;
    },
    SET_PENDING_TRIPS: (state, payload) => {
      state.pendingTrips = payload;
    },

    // trips actions
    CANCEL_REASON_OPEN: (state, payload) => {
      state.cancelReasonOpen = payload;
    },
    CANCEL_REASONS: (state, payload) => {
      state.cancelReasons = payload;
    },

    TRIP_ASSIGN_RIDER_OPEN: (state, payload) => {
      state.tripAssignRiderOpen = payload;
    },

    UPDATE_TRIP_STATUS_OPEN: (state, payload) => {
      state.updateTripStatusOpen = payload;
    }
  },
  actions: {
    // VEHICLE MODULE
    // Fetching All Vehicles
    fetchVehicles: async ({ commit }) => {
      Event.$emit("loading", true);
      commit("SET_ERROR", "");
      try {
        const user = AuthService.getUser();
        const res = await call("get", `partners/${user.id}/vehicles`);
        commit("GET_VEHICLES", res.data.data.response.data);
        Event.$emit("loading", false);
      } catch (err) {
        commit("SET_ERROR", err.response.data.data.response.data.message);
        Event.$emit("loading", false);
      }
    },

    // Fetching All Vehicle Types
    fetchVehicleTypes: async ({ commit }) => {
      Event.$emit("loading", true);
      commit("SET_ERROR", "");
      try {
        const res = await call("get", DashboardConstants.vehicleTypes);
        commit("GET_VEHICLE_TYPES", res.data.data.response.data);
        Event.$emit("loading", false);
      } catch (err) {
        commit("SET_ERROR", err.response.data.data.response.data.message);
        Event.$emit("loading", false);
      }
    },

    // Add New Vehicle
    addNewVehicle: async ({ commit }, data) => {
      commit("SET_ERROR", "");
      Event.$emit("modalLoading", true);
      try {
        await call("post", DashboardConstants.addNewVehicle, data);
        commit("VEHICLE_CREATION_MODAL", false);
        const modalDescription = `You have successfully created ${data.get(
          "reg_no"
        )}, as a new vehicle, Owner will receive a notification on their phone`;
        const modalText = `Onwer ID ${data.owner_id}`;
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_SUCCESS_MODAL", true);

        Event.$emit("modalLoading", false);
      } catch (err) {
        Event.$emit("modalLoading", false);
        const modalDescription = err?.response?.data?.data
          ? err.response?.data.data["Invalid data"].message
          : "Internal Server Error";
        const validationErrors =
          Object.values(err.response.data?.data["Invalid data"]?.data) || [];
        const modalText = validationErrors ? validationErrors[0][0] : "";
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_ERROR_MODAL", true);
      }
    },

    // DRIVER MODULE
    // Get Available Driver
    fetchDrivers: async ({ commit }) => {
      Event.$emit("loading", true);
      commit("SET_ERROR", "");
      try {
        const user = AuthService.getUser();
        const res = await call("get", `partners/${user.id}/riders`);
        const drivers = res.data.data.response.data;
        const activeDrivers = drivers.filter(d => d.verified === 1);
        const inactiveDrivers = drivers.filter(d => d.verified === 0);
        commit("SET_TOTAL_DRIVERS", drivers.length);
        commit("SET_ACTIVE_DRIVERS", activeDrivers.length);
        commit("SET_INACTIVE_DRIVERS", inactiveDrivers.length);
        commit("GET_DRIVERS", drivers);
        Event.$emit("loading", false);
      } catch (err) {
        commit("SET_ERROR", err.response.data.data.response.data.message);
        Event.$emit("loading", false);
      }
    },

    fetchDriverTrips: async ({ commit }, data) => {
      Event.$emit("loading", true);
      commit("SET_ERROR", "");
      try {
        const res = await call("get", `trip/${data.id}/all`);
        const driverTrips = res.data.data.response.data;
        commit("GET_DRIVER_TRIPS", driverTrips);
        Event.$emit("loading", false);
      } catch (err) {
        commit("SET_ERROR", err.response.data.data.response.data.message);
        Event.$emit("loading", false);
      }
    },

    // Add New Vehicle
    addNewDriver: async ({ commit }, data) => {
      commit("SET_ERROR", "");
      Event.$emit("modalLoading", true);
      try {
        await call("post", DashboardConstants.addNewDriver, data);
        commit("DRIVER_CREATION_MODAL", false);
        const name = data.get("first_name");
        const phone = data.get("phone_number");
        const modalDescription = `You have successfully created ${name}, as a new driver, they will receive a notification on their phone to activate their app`;
        const modalText = `Call ${phone}`;
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_SUCCESS_MODAL", true);
        Event.$emit("modalLoading", false);
      } catch (err) {
        Event.$emit("modalLoading", false);

        const modalDescription = err?.response?.data?.data
          ? err.response?.data?.data?.message
          : "Internal Server Error";
        const validationErrors =
          Object.values(err.response.data?.data?.response?.data) || [];
        const modalText = validationErrors ? validationErrors[0][0] : "";
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_ERROR_MODAL", true);
      }
    },

    // Update existing driver
    updateUserProfile: async ({ commit }, data) => {
      commit("SET_ERROR", "");
      Event.$emit("modalLoading", true);
      try {
        const res = await call("post", `user/${data.id}/update-personal`, data);
        const updatedUser = res.data.data.response.data;
        AuthService.setUser(updatedUser);

        Event.$emit("update-profile");
        Event.$emit("modalLoading", false);
      } catch (err) {
        commit("SET_ERROR", err.response.data.data.response.data.message);
        Event.$emit("modalLoading", false);
      }
    },

    // Update existing driver
    updateExistingDriver: async ({ commit }, data) => {
      commit("SET_ERROR", "");
      Event.$emit("modalLoading", true);
      try {
        const id = data.get("id");
        await call("post", `user/${+id}/update-personal`, data);
        commit("DRIVER_CREATION_MODAL", false);
        const name = data.get("first_name");
        const phone = data.get("phone_number");
        const modalDescription = `You have successfully Updated driver ${name}, they will receive a notification to confirm the update`;
        const modalText = `Call ${phone}`;
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_SUCCESS_MODAL", true);
        Event.$emit("modalLoading", false);
      } catch (err) {
        commit("SET_ERROR", err.response.data.data.response.data.message);
        Event.$emit("modalLoading", false);
      }
    },

    updateExistingVehicle: async ({ commit }, data) => {
      commit("SET_ERROR", "");
      Event.$emit("modalLoading", true);
      try {
        await call("post", `vehicle/${data.get("id")}/update`, data);
        commit("VEHICLE_CREATION_MODAL", false);
        const modalDescription = `You have successfully updated vehicle ${data.get(
          "reg_no"
        )}, Owner will receive a notification on their phone`;
        const modalText = `Onwer ID ${data.get("owner_id")}`;
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_SUCCESS_MODAL", true);

        Event.$emit("modalLoading", false);
      } catch (err) {
        Event.$emit("modalLoading", false);
        // commit("SET_ERROR", err.response.data.data.response.data.message);
        console.log(err)
      }
    },

    deleteVehicle: async ({ commit }, data) => {
      commit("SET_ERROR", "");
      Event.$emit("modalLoading", true);
      try {
        await call("post", `vehicle/${data.id}/delete`, {});
        commit("SHOW_WARNING_MODAL", false);
        const modalDescription = `Vehicle ${data.reg_no} has been successfully deleted`;
        const modalText = `An email sent to owner to notify them of they deletion`;
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_SUCCESS_MODAL", true);
        Event.$emit("modalLoading", false);
      } catch (err) {
        Event.$emit("modalLoading", false);
        commit("SET_ERROR", err.response.data.data.response.data.message);
      }
    },

    // Assign driver a vehicle
    assignDriverVehicle: async ({ commit }, data) => {
      commit("SET_ERROR", "");
      Event.$emit("modalLoading", true);
      try {
        await call(
          "get",
          `partners/assign/${data.rider_id}/vehicle/${data.vehicle_id}`
        );
        const modalDescription = `You have successfully Assigned driver ${data.rider_name} to vehicle ${data.vehicle_name}`;
        const modalText = "They will receive a notification to inform them";
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_SUCCESS_MODAL", true);
        Event.$emit("modalLoading", false);
      } catch (err) {
        commit("SET_ERROR", err.response.data.data.response.data.message);
        Event.$emit("modalLoading", false);
      }
    },

    //TRIPS MODULE
    //fetch trips
    fetchTrips: async ({ commit }) => {
      Event.$emit("loading", true);
      commit("SET_ERROR", "");
      try {
        const user = AuthService.getUser();
        const res = await call("get", `partners/${user.id}/trips`);
        const trips = res.data.data.response.data;
        const pendingTrips = trips.filter(
          t => t.status === "ordered" || t.status === "allocated"
        );
        const completedTrips = trips.filter(t => t.status === "delivered");
        commit("SET_TOTAL_TRIPS", trips.length);
        commit("SET_COMPLETED_TRIPS", completedTrips.length);
        commit("SET_PENDING_TRIPS", pendingTrips.length);
        commit("GET_TRIPS", trips);
        Event.$emit("loading", false);
      } catch (err) {
        commit("SET_ERROR", err.response.data.data.response.data.message);
        Event.$emit("loading", false);
      }
    },

    addNewTrip: async ({ commit }, data) => {
      commit("SET_ERROR", "");
      Event.$emit("modalLoading", true);
      try {
        await call("post", "trip/new", data);
        const modalDescription =
          "You have successfully added new Trip. Trip recipient will receive a notification on their Phone.";
        const modalText = `Call ${data.recipient_phone_number}`;
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_SUCCESS_MODAL", true);
        Event.$emit("modalLoading", false);
      } catch (err) {
        commit("SET_ERROR", err.response.data.data.response.data.message);

        const modalDescription = err?.response?.data?.data
          ? err.response?.data?.data?.response?.message
          : "Internal Server Error";
        const validationErrors =
          Object.values(err.response.data?.data?.response?.data) || [];
        const modalText = validationErrors ? validationErrors[0][0] : "";
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_ERROR_MODAL", true);
        Event.$emit("modalLoading", false);
      }
    },

    updateExistingTrip: async ({ commit }, data) => {
      commit("SET_ERROR", "");
      Event.$emit("modalLoading", true);
      try {
        await call("post", `trip/${data.id}/update`, data);
        const modalDescription =
          "You have successfully added updated a Trip. Trip recipient will receive a notification on their Phone to inform them.";
        const modalText = `Press complete to continue`;
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_SUCCESS_MODAL", true);
        Event.$emit("modalLoading", false);
      } catch (err) {
        commit("SET_ERROR", err.response.data.data.response.data.message);

        const modalDescription = err?.response?.data?.data
          ? err.response?.data?.data?.response?.message
          : "Internal Server Error";
        const validationErrors =
          Object.values(err.response.data?.data?.response?.data) || [];
        const modalText = validationErrors ? validationErrors[0][0] : "";
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_ERROR_MODAL", true);
        Event.$emit("modalLoading", false);
      }
    },

    //PAYMENT MODULE
    //fetch payments
    fetchPayments: async ({ commit }) => {
      Event.$emit("loading", true);
      commit("SET_ERROR", "");
      try {
        const user = AuthService.getUser();
        const res = await call("get", `partners/${user.id}/payments`);
        commit("GET_PAYMENTS", res.data.data.response.data);
        Event.$emit("loading", false);
      } catch (err) {
        commit("SET_ERROR", err.response.data.data.response.data.message);
        Event.$emit("loading", false);
      }
    },

    fetchPaymentModes: async ({ commit }) => {
      Event.$emit("loading", true);
      commit("SET_ERROR", "");
      try {
        const res = await call("get", "payment-types");
        commit("GET_PAYMENT_MODES", res.data.data.response.data);
        Event.$emit("loading", false);
      } catch (err) {
        commit("SET_ERROR", err.response.data.data.response.data.message);
        Event.$emit("loading", false);
      }
    },

    // Activate User
    activateUser: async ({ commit }, data) => {
      commit("SET_ERROR", "");
      Event.$emit("modalLoading", true);
      try {
        await call("post", `users/${data.id}/activate`, {});
        commit("SHOW_WARNING_MODAL", false);
        const modalDescription = `You have successfully activated ${data.name}, They will receive a notification to inform them of their activation`;
        const modalText = `Call ${data.phone_number}`;
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_SUCCESS_MODAL", true);
        Event.$emit("modalLoading", false);
      } catch (err) {
        commit("SHOW_WARNING_MODAL", false);
        const modalDescription = `${err.response.data.data.response.message}`;
        const modalText = "Press Retry to try again";
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_ERROR_MODAL", true);
        Event.$emit("modalLoading", false);
      }
    },

    // deactivate User
    deactivateUser: async ({ commit }, data) => {
      commit("SET_ERROR", "");
      Event.$emit("modalLoading", true);
      try {
        await call("post", `users/${data.id}/deactivate`, {});
        commit("SHOW_WARNING_MODAL", false);
        const modalDescription = `You have successfully deactivated  ${data.name}, they will receive a notification to inform them of their deactivation`;
        const modalText = `Call ${data.phone_number}`;
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_SUCCESS_MODAL", true);
        Event.$emit("modalLoading", false);
      } catch (err) {
        commit("SHOW_WARNING_MODAL", false);
        const modalDescription = `${err.response.data.data.response.message}`;
        const modalText = "Press Retry to try again";
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_ERROR_MODAL", true);
        Event.$emit("modalLoading", false);
      }
    },

    // Activate Vehicle
    activateVehicle: async ({ commit }, data) => {
      commit("SET_ERROR", "");
      Event.$emit("modalLoading", true);
      try {
        await call("get", `vehicle/${data.id}/activate`, {});
        commit("SHOW_WARNING_MODAL", false);
        const modalDescription = `You have successfully activated ${data.reg_no}`;
        const modalText = `Vehicle ${data.reg_no}`;
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_SUCCESS_MODAL", true);
        Event.$emit("modalLoading", false);
      } catch (err) {
        commit("SHOW_WARNING_MODAL", false);
        const modalDescription = `${err.response.data.data.response.message}`;
        const modalText = "Press Retry to try again";
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_ERROR_MODAL", true);
        Event.$emit("modalLoading", false);
      }
    },

    // Deactivate Vehicle
    deactivateVehicle: async ({ commit }, data) => {
      commit("SET_ERROR", "");
      Event.$emit("modalLoading", true);
      try {
        await call("get", `vehicle/${data.id}/deactivate`, {});
        commit("SHOW_WARNING_MODAL", false);
        const modalDescription = `You have successfully activated ${data.reg_no}`;
        const modalText = `Vehicle ${data.reg_no}`;
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_SUCCESS_MODAL", true);
        Event.$emit("modalLoading", false);
      } catch (err) {
        commit("SHOW_WARNING_MODAL", false);
        const modalDescription = `${err.response.data.data.response.message}`;
        const modalText = "Press Retry to try again";
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_ERROR_MODAL", true);
        Event.$emit("modalLoading", false);
      }
    },

    // Creation and update modals
    showDriverCreationModal: ({ commit }) =>
      commit("DRIVER_CREATION_MODAL", true),
    hideDriverCreationModal: ({ commit }) =>
      commit("DRIVER_CREATION_MODAL", false),
    showDriverUpdateModal: ({ commit }) => commit("DRIVER_UPDATE_MODAL", true),
    hideDriverUpdateModal: ({ commit }) => commit("DRIVER_UPDATE_MODAL", false),

    showTripUpdateModal: ({ commit }) => commit("TRIP_UPDATE_MODAL", true),
    hideTripUpdateModal: ({ commit }) => commit("TRIP_UPDATE_MODAL", false),

    showVehicleCreationModal: ({ commit }) =>
      commit("VEHICLE_CREATION_MODAL", true),
    hideVehicleCreationModal: ({ commit }) =>
      commit("VEHICLE_CREATION_MODAL", false),
    showVehicleUpdateModal: ({ commit }) =>
      commit("VEHICLE_UPDATE_MODAL", true),
    hideVehicleUpdateModal: ({ commit }) =>
      commit("VEHICLE_UPDATE_MODAL", false),

    // Set update datas actions
    setUpdateDriver: ({ commit }, data) => commit("SET_UPDATE_DRIVER", data),
    setUpdateVehicle: ({ commit }, data) => commit("SET_UPDATE_VEHICLE", data),

    setUpdateTrip: ({ commit }, data) => commit("SET_UPDATE_TRIP", data),

    //Notification modals
    showSuccessModal: ({ commit }) => commit("SHOW_SUCCESS_MODAL", true),
    showErrorModal: ({ commit }) => commit("SHOW_ERROR_MODAL", true),
    showWarningModal: ({ commit }) => commit("SHOW_WARNING_MODAL", true),

    hideSuccessModal: ({ commit }) => commit("SHOW_SUCCESS_MODAL", false),
    hideErrorModal: ({ commit }) => commit("SHOW_ERROR_MODAL", false),
    hideWarningModal: ({ commit }) => commit("SHOW_WARNING_MODAL", false),

    setModalDescription: ({ commit }, data) => {
      commit("SET_MODAL_DESCRIPTION", data);
    },

    setModalText: ({ commit }, data) => {
      commit("SET_MODAL_TEXT", data);
    },

    // trips actions
    cancelTrip: async ({ commit }, data) => {
      commit("SET_ERROR", "");
      Event.$emit("modalLoading", true);
      try {
        await call("post", `trip/${data.id}/cancel`, {
          cancel_reason: data.reason
        });
        commit("CANCEL_REASON_OPEN", false);
        const modalDescription = `You have successfully canceled trip for recipient ${data.recipient_name}`;
        const modalText = `Call ${data.recipient_phone_number}`;
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_SUCCESS_MODAL", true);
        Event.$emit("modalLoading", false);
      } catch (err) {
        commit("SHOW_WARNING_MODAL", false);
        const modalDescription = `${err.response.data.data.response.message}`;
        const modalText = "Press Retry to try again";
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_ERROR_MODAL", true);
        Event.$emit("modalLoading", false);
      }
    },

    assignTripRider: async ({ commit }, data) => {
      commit("SET_ERROR", "");
      Event.$emit("modalLoading", true);
      try {
        await call("post", `trip/${data.id}/assign-rider`, {
          rider_id: data.rider_id
        });
        commit("CANCEL_REASON_OPEN", false);
        const modalDescription = `You have successfully assign driver to trip for recipient ${data.recipient_name}`;
        const modalText = `Call ${data.recipient_phone_number}`;
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_SUCCESS_MODAL", true);
        Event.$emit("modalLoading", false);
      } catch (err) {
        commit("SHOW_WARNING_MODAL", false);
        const modalDescription = `${err.response.data.data.response.message}`;
        const modalText = "Press Retry to try again";
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_ERROR_MODAL", true);
        Event.$emit("modalLoading", false);
      }
    },

    updateTripStatus: async ({ commit }, data) => {
      commit("SET_ERROR", "");
      Event.$emit("modalLoading", true);
      try {
        await call("post", `trip/${data.id}/change_status`, {
          status: data.status
        });
        commit("CANCEL_REASON_OPEN", false);
        const modalDescription = `You have successfully updated status to trip for recipient ${data.recipient_name}`;
        const modalText = `Call ${data.recipient_phone_number}`;
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_SUCCESS_MODAL", true);
        Event.$emit("modalLoading", false);
      } catch (err) {
        commit("SHOW_WARNING_MODAL", false);
        const modalDescription = `${err.response.data.data.response.message}`;
        const modalText = "Press Retry to try again";
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_ERROR_MODAL", true);
        Event.$emit("modalLoading", false);
      }
    },

    deleteTrip: async ({ commit }, data) => {
      commit("SET_ERROR", "");
      Event.$emit("modalLoading", true);
      try {
        await call("post", `trip/${data.id}/delete`, {});
        const modalDescription = `You have successfully deleted trip for recipient ${data.recipient_name}`;
        const modalText = `Call ${data.recipient_phone_number}`;
        commit("SET_WARNING_MODAL", false);
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_SUCCESS_MODAL", true);
        Event.$emit("modalLoading", false);
      } catch (err) {
        commit("SHOW_WARNING_MODAL", false);
        const modalDescription = `${err.response.data.data.response.message}`;
        const modalText = "Press Retry to try again";
        commit("SET_MODAL_DESCRIPTION", modalDescription);
        commit("SET_MODAL_TEXT", modalText);
        commit("SHOW_ERROR_MODAL", true);
        Event.$emit("modalLoading", false);
      }
    },

    showCancelReasonOpen: ({ commit }) => commit("CANCEL_REASON_OPEN", true),
    hideCancelReasonOpen: ({ commit }) => commit("CANCEL_REASON_OPEN", false),

    showTripAssignRiderOpen: ({ commit }) =>
      commit("TRIP_ASSIGN_RIDER_OPEN", true),
    hideTripAssignRiderOpen: ({ commit }) =>
      commit("TRIP_ASSIGN_RIDER_OPEN", true),

    showUpdateTripStatusOpen: ({ commit }) =>
      commit("UPDATE_TRIP_STATUS_OPEN", true),
    hideUpdateTripStatusOpen: ({ commit }) =>
      commit("UPDATE_TRIP_STATUS_OPEN", true),

    getCancelReasons: async ({ commit }) => {
      Event.$emit("loading", true);
      commit("SET_ERROR", "");
      try {
        const res = await call("get", "trip-cancel-reason");
        commit("CANCEL_REASONS", res.data.data.response.data);
        console.log(res.data.data.response.data);
        Event.$emit("loading", false);
      } catch (err) {
        commit("SET_ERROR", err.response.data.data.response.data.message);
        Event.$emit("loading", false);
      }
    }
  },
  getters: {
    error: state => state.error,
    vehicles: state => state.vehicles,
    vehicleTypes: state => state.vehicleTypes,
    drivers: state => state.drivers,
    trips: state => state.trips,
    payments: state => state.payments,
    paymentModes: state => state.paymentModes,
    driverTrips: state => state.driverTrips,

    //creation and update modal
    driverCreationModal: state => state.driverCreationModal,
    vehicleCreationModal: state => state.vehicleCreationModal,
    vehicleUpdateModal: state => state.vehicleUpdateModal,
    driverUpdateModal: state => state.driverUpdateModal,
    tripUpdateModal: state => state.tripUpdateModal,

    // update data
    updateDriver: state => state.updateDriver,
    updateVehicle: state => state.updateVehicle,
    updateTrip: state => state.updateTrip,

    //Notification modals
    showSuccessModal: state => state.showSuccessModal,
    showErrorModal: state => state.showErrorModal,
    showWarningModal: state => state.showWarningModal,
    modalDescription: state => state.modalDescription,
    modalText: state => state.modalText,

    // Dashboard
    totalDrivers: state => state.totalDrivers,
    activeDrivers: state => state.activeDrivers,
    inactiveDrivers: state => state.inactiveDrivers,

    totalTrips: state => state.totalTrips,
    completedTrips: state => state.completedTrips,
    pendingTrips: state => state.pendingTrips,

    // trip actions
    cancelReasonOpen: state => state.cancelReasonOpen,
    cancelReasons: state => state.cancelReasons,

    tripAssignRiderOpen: state => state.tripAssignRiderOpen,
    updateTripStatusOpen: state => state.updateTripStatusOpen
  }
};
